var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selecting"},[_c('div',{staticClass:"border-circle"},[_vm._t("img",[_c('img',{staticClass:"circle-pic img-fluid",attrs:{"src":"https://i.imgur.com/SbZteZz.png","alt":""}})])],2),_vm._v(" "),_vm._t("title",[_c('h5',{staticClass:"mt-4 text-center"},[_vm._v("Krovinių transportavimas užsakovams")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a8d711c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rounded.vue
// module id = 350
// module chunks = 0